/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }

    this.querySelectorAll('[data-color-swatches]').forEach(element => {
      let hideSwatches = element.querySelectorAll('li.d-none');
      let allSwatches = element.querySelectorAll('li');
      if (hideSwatches.length == allSwatches.length) {
        element.closest('[data-color-parent-swatches]')?.classList.add('d-none');
      }
    });
    let visibleParentSwatchEle = this.querySelectorAll('[data-color-parent-swatches]:not(.d-none)');
    if (visibleParentSwatchEle.length == 1) {
      visibleParentSwatchEle[0]?.querySelector('[data-group-price]')?.classList.add('d-none')
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  async onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? document.getElementById('cart--items').dataset.id : 'component-cart-drawer')},header` 
    });
    if (window.updae_line_index > 0) {
      const body_1 = JSON.stringify({
        line: window.updae_line_index,
        quantity: 0
      });
      await fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body : body_1 }});
    }
    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then(async (res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors?.email || JSON.stringify(dataJSON.errors), {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      
      if(qtyInput) qtyInput.value = 1;      
      window.updae_line_index = 0;
      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer',true);
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    let max = $qtyInput.getAttribute('max');
    if (max != undefined && action == 'increase') {
      max = parseInt(max);
      if (max <= currentQty) {
        increaseQtyBtn.classList.add('disabled')
        return false;
      }else{
        increaseQtyBtn.classList.remove('disabled')
      }
    }
    increaseQtyBtn.classList.remove('disabled')
    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
const productVariantsHtml = {};
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    this.product_json = this.form.querySelector('[data-productJSON]') ? JSON.parse(this.form.querySelector('[data-productJSON]').innerText) : false
    // this.variant_available_json = [];
    // this.form.querySelectorAll('[data-variant-available]').forEach((ele)=>{
    //   this.variant_available_json.push(JSON.parse(ele.innerText))
    // })
    Shopify.optionsMap = {};
    Shopify.disabledOptionsMap = {};
    this.defualtProduct(); 
  }

  defualtProduct() {
    var product = this.closest('product-form')?.querySelector('[data-currentProductJson]') ? JSON.parse(this.closest('product-form')?.querySelector('[data-currentProductJson]')?.innerHTML) : [];
    var hiddenIds = [];
    var hiddenIdsEl = this.closest('product-form')?.querySelector('[data-hiddenVariantIds]');
    if (hiddenIdsEl) {
      try { hiddenIds = JSON.parse(hiddenIdsEl.textContent); } catch(e) {}
    }
    if (product?.variants?.length > 0) {
      for (var i = 0; i < product?.variants?.length; i++) {
        var variant = product.variants[i];
        if (hiddenIds.includes(variant.id)) continue;
        
        if (variant.available) {
          // Gathering values for the 1st drop-down.
          if (product.options.length === 1) {
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            if (!Shopify.optionsMap['root'].includes(variant.option1)) {
              Shopify.optionsMap['root'].push(variant.option1);
            }
          } 
      
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            if (!Shopify.optionsMap[key].includes(variant.option2)) {
              Shopify.optionsMap[key].push(variant.option2);
            }
          } 
      
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            if (!Shopify.optionsMap[key].includes(variant.option3)) {
              Shopify.optionsMap[key].push(variant.option3);
            }
          }
        } else {
          // Gathering values for the 1st drop-down.
          if (product.options.length === 1) {
            Shopify.disabledOptionsMap['root'] = Shopify.disabledOptionsMap['root'] || [];
            if (!Shopify.disabledOptionsMap['root'].includes(variant.option1)) {
              Shopify.disabledOptionsMap['root'].push(variant.option1);
            }
          } 
      
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            Shopify.disabledOptionsMap[key] = Shopify.disabledOptionsMap[key] || [];
            if (!Shopify.disabledOptionsMap[key].includes(variant.option2)) {
              Shopify.disabledOptionsMap[key].push(variant.option2);
            }
          } 
      
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            Shopify.disabledOptionsMap[key] = Shopify.disabledOptionsMap[key] || [];
            if (!Shopify.disabledOptionsMap[key].includes(variant.option3)) {
              Shopify.disabledOptionsMap[key].push(variant.option3);
            }
          }
        }
      }
      this.checkOptionSelection();
    }
  }

  checkOptionSelection() {
    const that = this;
    var mainProductWrapper = this.closest('product-form');
    var optionCount = mainProductWrapper.querySelectorAll('form fieldset.product-form__input');
    var variantNeededDataJson = JSON.parse(this.closest('product-form')?.querySelector('[data-variantNeededDataJson]')?.innerHTML) || [];
  
    if (optionCount.length === 1) {
      // for option default available
      Shopify.optionsMap["root"]?.forEach(function(option1, i) {
        var varJson = variantNeededDataJson[option1];
        if ((varJson.diff == false && varJson.inventory_quantity > 0) || varJson.inventory_management == false) {
          optionCount[0].querySelector(`ul input[value="${option1}"]+label`)?.closest('li')?.classList.add('active');
        } else {
          if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff > 0 && varJson.diff <= 30 && varJson.continue_selling == true) {
            optionCount[0].querySelector(`ul input[value="${option1}"]+label`)?.closest('li')?.classList.add('active');
          } else if (varJson.continue_selling == true && varJson.inventory_quantity > 0) {
            optionCount[0].querySelector(`ul input[value="${option1}"]+label`)?.closest('li')?.classList.add('active');
          }
        }
      });

      // for option default sold out available
      Shopify.disabledOptionsMap["root"]?.forEach(function(option1, i) {
        var varJson = variantNeededDataJson[option1];
        if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
          optionCount[0].querySelector(`ul input[value="${option1}"]+label`)?.closest('li')?.classList.add('active');
        } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
          optionCount[0].querySelector(`ul input[value="${option1}"]+label`)?.closest('li')?.classList.add('active');
        }
      });
    }
  
    if (optionCount.length === 2) {
      var option1 = mainProductWrapper.querySelector('form fieldset.product-form__input[data-optionindex="1"] input:checked')?.value;
      var option2 = mainProductWrapper.querySelector('form fieldset.product-form__input[data-optionindex="2"] input:checked')?.value;
      
      if (option1) {
        // for option 1 default available
        Shopify.optionsMap[option1]?.forEach(function(value) {
          var varJson = variantNeededDataJson[`${option1} / ${value}`];
          if (varJson.diff == false || varJson.inventory_management == false) {
            optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          } else {
            if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
              optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
            } else if (varJson.continue_selling == true && varJson.inventory_quantity > 0) {
              optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
            }
          }
        });
      }
      
      if (option2) {
        // for option 2 default available
        Object.keys(Shopify.optionsMap).forEach(function(key) {
          var value = Shopify.optionsMap[key];
          var selector = optionCount[0].querySelector(`ul input[value="${key}"]+label`);
          
          if (value.includes(option2)) {
            var varJson = variantNeededDataJson[`${key} / ${option2}`];
            if (varJson.diff == false || varJson.inventory_management == false) {
              if (selector) selector?.closest('li')?.classList.add('active');
            } else {
              if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
                if (selector) selector?.closest('li')?.classList.add('active');
              } else if (varJson.continue_selling == true && varJson.inventory_quantity > 0) {
                if (selector) selector?.closest('li')?.classList.add('active');
              }
            }
          }
        });
      }

      if (option1) {
        // for option 1 default sold out available
        Shopify.disabledOptionsMap[option1]?.forEach(function(value) {
          var varJson = variantNeededDataJson[`${option1} / ${value}`];
          if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
            optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
            optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          }
        });
      }

      if (option2) {
        // for option 2 default sold out available
        Object.keys(Shopify.disabledOptionsMap).forEach(function(key) {
          var value = Shopify.disabledOptionsMap[key];
          var selector = optionCount[0].querySelector(`ul input[value="${key}"]+label`);
          
          if (value.includes(option2)) {
            var varJson = variantNeededDataJson[`${key} / ${option2}`];
            if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
              if (selector) selector?.closest('li').classList.add('active');
            } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
              if (selector) selector?.closest('li').classList.add('active');
            }
          }
        });
      }
    }
    if (optionCount.length === 3) {
      var option1 = mainProductWrapper.querySelector('form fieldset.product-form__input[data-optionindex="1"] input:checked')?.value;
      var option2 = mainProductWrapper.querySelector('form fieldset.product-form__input[data-optionindex="2"] input:checked')?.value;
      var option3 = mainProductWrapper.querySelector('form fieldset.product-form__input[data-optionindex="3"] input:checked')?.value;

      if (option1 && option2) {
        var option2Names = `${option1} / ${option2}`;
        Shopify.optionsMap[option2Names]?.forEach(function(option3Val) {
          var varJson = variantNeededDataJson[`${option2Names} / ${option3Val}`];
          if (!varJson) return;
          var selector = optionCount[2].querySelector(`ul input[value="${option3Val}"]+label`);
          if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
            if (selector) selector?.closest('li').classList.add('active');
          } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
            if (selector) selector?.closest('li').classList.add('active');
          } else if (varJson.inventory_quantity > 0) {
            if (selector) selector?.closest('li')?.classList.add('active');
          } else if (varJson.inventory_management == false) {
            if (selector) selector?.closest('li').classList.add('active');
          }
        });
      }

      var customOption1 = [];
      mainProductWrapper.querySelectorAll('form fieldset.product-form__input[data-optionindex="1"] input').forEach(item => customOption1.push(item.value));

      customOption1.forEach(function(value) {
        if (!option2) return;
        var customOptionName = value + " / " + option2;
        var thirdChoices = Shopify.optionsMap[customOptionName];
        if (thirdChoices === undefined || !thirdChoices.length) return;
        var matchesThird =
          option3 != null && option3 !== ""
            ? thirdChoices.includes(option3)
            : true;
        if (matchesThird) {
          optionCount[0].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
        }
      });

      var customOption2 = [];
      mainProductWrapper.querySelectorAll('form fieldset.product-form__input[data-optionindex="2"] input').forEach(item => customOption2.push(item.value));
      
      customOption2.forEach(function(value) {
        if (!option1) return;
        var customOptionName = option1 + " / " + value;
        var thirdChoices = Shopify.optionsMap[customOptionName];
        if (thirdChoices === undefined || !thirdChoices.length) return;
        var matchesThird =
          option3 != null && option3 !== ""
            ? thirdChoices.includes(option3)
            : true;
        if (matchesThird) {
          optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
        }
      });

      var customOption3 = [];
      mainProductWrapper.querySelectorAll('form fieldset.product-form__input[data-optionindex="3"] input').forEach(item => customOption3.push(item.value));

      customOption3.forEach(function(option3New) {
        var customOptionName = `${option1} / ${option2} / ${option3New}`;
        var varJson = variantNeededDataJson[customOptionName];
        if (varJson?.inventory_quantity > 0 || varJson?.inventory_management == false) {
          optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
        } else if (varJson?.available_to_backorder > 0 && varJson?.inventory_quantity <= 0 && (varJson?.price <= 2500 || varJson?.diff > 30) && varJson?.continue_selling == false) {
          optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
        } else if (varJson?.available_to_backorder > 0 && varJson?.inventory_quantity <= 0 && varJson?.price > 2500 && varJson?.diff <= 30 && varJson?.continue_selling == true) {
          optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
        }
      });

      // option checking for the default sold out available
      Shopify.disabledOptionsMap[option1]?.forEach(function(value) {
        var varJson = variantNeededDataJson[`${option1} / ${value} / ${option3}`];
        if (!varJson) return;
        if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
          optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
        } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
          optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
        } else if (varJson.inventory_quantity > 0 || varJson.inventory_management == false) {
          optionCount[1].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
        }
      });

      customOption1.forEach(function(value) {
        var customOptionName = value + " / " + option2;
        if (Shopify.disabledOptionsMap[customOptionName] !== undefined && Shopify.disabledOptionsMap[customOptionName].includes(option3)) {
          var varJson = variantNeededDataJson[`${value} / ${option2} / ${option3}`];
          if (!varJson) return;
          if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
            optionCount[0].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
            optionCount[0].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          }else if (varJson.inventory_quantity > 0 || varJson.inventory_management == false) {
            optionCount[0].querySelector(`ul input[value="${value}"]+label`)?.closest('li')?.classList.add('active');
          }
        }
      });

      var customOption3 = [];
      mainProductWrapper.querySelectorAll('form fieldset.product-form__input[data-optionindex="3"] input').forEach(item => customOption3.push(item.value));

      customOption3.forEach(function(option3New) {
        customOption2.forEach(function(value) {
          var customOptionName = option1 + " / " + value;
          if (Shopify.disabledOptionsMap[customOptionName] !== undefined && Shopify.disabledOptionsMap[customOptionName].includes(option3New)) {
            var varJson = variantNeededDataJson[`${option1} / ${value} / ${option3New}`];
            if (!varJson) return;
            if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && (varJson.price <= 2500 || varJson.diff > 30) && varJson.continue_selling == false) {
              optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
            } else if (varJson.available_to_backorder > 0 && varJson.inventory_quantity <= 0 && varJson.price > 2500 && varJson.diff <= 30 && varJson.continue_selling == true) {
              optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
            }else if (varJson.inventory_quantity > 0 || varJson.inventory_management == false) {
              optionCount[2].querySelector(`ul input[value="${option3New}"]+label`)?.closest('li')?.classList.add('active');
            }
          }
        });
      });
    }

    if (this.closest('[data-template="product"]')) {
      var currentVariant = this.closest('product-form')?.querySelector('[data-currentVariantJson]') ? JSON.parse(this.closest('product-form')?.querySelector('[data-currentVariantJson]')?.innerHTML) : [];
      var currentVariantOptions = currentVariant?.options;
      var optionAvailability = []
      if(currentVariantOptions) {
        currentVariantOptions.map((option, index) => {
          var activeInput = mainProductWrapper.querySelector(`form fieldset.product-form__input[data-optionindex="${index+1}"] input[value="${option}"]`)?.closest('li')?.classList.contains('active');
          optionAvailability.push(activeInput);
        })
        const hasTrueValue = optionAvailability.some(value => value == true);
        if(!hasTrueValue) this.closest('product-form')?.querySelector('form')?.classList.add('show-forcefully-option');
      } 
    }
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.form.querySelectorAll('[name="size"]:checked+label').forEach((ele)=>{
      ele.addEventListener('click',()=>{
        this.form.querySelectorAll('.unselect,.hide-oos-line')?.forEach(element => {
          element.classList.remove('unselect','hide-oos-line')
        });
        this.form.querySelector('[name="select-size"]')?.classList.add('d-none');
        let notifyMe = this.form.querySelector('[data-notify-me]');
        this.form.querySelector('[data-backorder-date]')?.classList.remove('d-none');
        if (notifyMe) {
          notifyMe.classList.remove('d-none');
          this.form.querySelector('[name="add"]')?.classList.add('d-none');
        }else{
          this.form.querySelector('[name="add"]')?.classList.remove('d-none');
        }
      })
    })
    TemplateProductJS?.prototype.init_zoom();
  }

  updateProductHtml=()=>{
    this.onVariantChange('update')
   
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    var closestLi = null;
    this.swapProductURL = null;
    this.selectedOptionsIndex =  Array.from(this.form.querySelectorAll('variant-radios fieldset ul li input:checked')).map((ele) => ele.closest('li')?.getAttribute('data-product-option-id'));
    
    if (_event != 'load' && _event != 'update') {
      this.selectedSwatchType = _event.target.closest('.swatch')?.querySelector('input')?.getAttribute('name');
      this.isSizeSelected = this.form.querySelector('.unselect') ? false : true;
      closestLi = _event.target.closest('li');
      this.swapProductURL = closestLi?.getAttribute('data-product-url');
    }else if (_event == 'update'){
      this.selectedSwatchType = 'size';
      this.isSizeSelected = this.form?.querySelector('.unselect') ? false : true;
      closestLi = _event?.target?.closest('li');
      this.swapProductURL = closestLi?.getAttribute('data-product-url');
    }
    if (this.formType == 'grid' && !this.closest('cart-form')) {
      let id = _event.target.closest('[data-variant-id]').getAttribute('data-variant-id');
      this.currentVariant = this._getVariantData().find(variant => variant.id == id);
    }
    else {
      this.setCurrentVariant();
    }
    (this.currentVariant !== undefined) && (window.currentVariantJson = this.currentVariant);
    // TemplateProductJS.prototype.init_zoom();
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant && this.swapProductURL == null) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
        this.toggleAddButton('enable');
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage, _event);
      }
      this.updateURLandID(this.currentVariant);
    }
    if (this.querySelector('[data-product-url]')) {
      this.updateUnavailableCombinations();
    }
  }

  /**
   * Find all unavailable variant combinations and store them
   */
  updateUnavailableCombinations() {
    let combinedListingURL = this.querySelectorAll('[data-product-url] input:not(:checked)');
    combinedListingURL.forEach(async item => {
      // Convert NodeList to Array before using filter
      let closest = item.closest('[data-product-url]');
      let url = closest.getAttribute('data-product-url');
      let combinedListingOptionID = closest.getAttribute('data-product-option-id');
      
      let checkedOptions = Array.from(this.querySelectorAll('fieldset:not(:has([data-product-url])) input:checked'));
      let restOfTheOptions = checkedOptions.map(input => input.closest('[data-product-option-id]').getAttribute('data-product-option-id')).filter(Boolean);
      
      this.classList.add('disabled');
      this.form.querySelector('[data-loading-overlay]')?.classList.remove('d-none');
      let fetchURL = `${url}?option_values=${combinedListingOptionID},${restOfTheOptions.toString()}`;
      let response = await fetch(fetchURL);
      let data = await response.text();
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, 'text/html');
      let productWrapper = doc.querySelector('[data-product-wrapper]');
      const variant = JSON.parse(productWrapper.querySelector('[data-currentVariantJson]').innerText);
      if (!variant) {
        console.log(combinedListingOptionID,'combinedListingOptionID')
        this.form.querySelector(`[data-product-option-id="${combinedListingOptionID}"]`)?.classList.remove('active');
        // this.form.querySelector(`[data-product-option-id="${combinedListingOptionID}"]`)?.setAttribute('disabled',true);
      }
      this.classList.remove('disabled');
      this.form.querySelector('[data-loading-overlay]')?.classList.add('d-none');
      
    })
    // this.allCombinations = [];
    // if (this.product_json.options.length == 3) {
    //   this.product_json.variants.forEach(variant => {
    //     this.allCombinations.push(variant.options);
    //   })
    // }
    // console.log(this.allCombinations,'this.allCombinations')
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
    const quickShopBtn = productGrid.querySelector('[data-quick-shop]');
    if(quickShopBtn) quickShopBtn.setAttribute('data-quick-view-variant-id', this.currentVariant.id);
    this._updateDropdownOptions(productGrid);
  }

  _updateDropdownOptions(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantData = this._getVariantData();
    const selects = productGrid.querySelectorAll('variant-selects select[data-option-index]');
    selects.forEach(select => {
      const optIdx = parseInt(select.getAttribute('data-option-index'));
      select.querySelectorAll('option').forEach(option => {
        const value = option.value;
        const hasVisibleVariant = variantData.some(variant => {
          if(variant.options[optIdx] !== value) return false;
          for(let j = 0; j < optIdx; j++){
            if(variant.options[j] !== this.currentVariant.options[j]) return false;
          }
          return true;
        });
        if(hasVisibleVariant){
          option.removeAttribute('disabled');
        } else {
          option.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset?.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked)?.value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    if (this.closest('cart-form')) {
      options = Array.from(this.form.querySelectorAll('input:checked,select')).map((ele) => {
        return ele.value
      });
    }
    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });

    // this.variant_json.forEach((variant)=>{
    //   let availability = this.variant_available_json.find((item) => item.id == variant.id);
    // })
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.textContent = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);;
    if(comparePriceElement) {
      comparePriceElement.textContent = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price == currentVariant.price){
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.classList.remove('d-none');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container, _event) {
    if((!currentVariant || !container) && this.swapProductURL == null) return;
    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        this.priceUpdate(currentVariant, container);
        this.updateOptionLabel(this.form); 
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src+ '&width=100';
        featuredImage.srcset = currentVariant.featured_image.src + '&width=500';
        this.closest('[data-product-grid]')?.querySelector('href')?.setAttribute('href',currentVariant.url)

        try{
          let secondary_image_ele = container?.querySelector('[data-hoverImage]');
          if (this.product_json && secondary_image_ele) {
            let secondary_image = this.product_json.media.find((image) => image.alt.includes(currentVariant.option1) && currentVariant.featured_image.src != image.src);
            if (secondary_image) {
              secondary_image_ele.src = secondary_image.src+ '&width=100';
              secondary_image_ele.srcset = secondary_image.src + '&width=500';
              secondary_image_ele?.classList.remove('d-none');
              featuredImage?.closest('a')?.classList.remove('single-img');
            }else{
              secondary_image_ele?.classList.add('d-none');
              featuredImage?.closest('a')?.classList.add('single-img');
            }
          }
        }catch(err){
          console.log(err,'<==err')
        }

      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        
        
          if (imageSlide) {
            let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
            if(this.formType == 'quickshop' && quickShopSlider){
              quickShopSlider.slideTo(slideIndex, 0, false);
            }else if(productSlider){
              productSlider.slideTo(slideIndex, 0, false);
            }
          }
      }
    }
    if (_event != 'load') {
      if (this.formType != 'grid' && (currentVariant || this.swapProductURL != null)) {
        this.fetchProductDetail(_event,currentVariant);
      }
    }
  }

  fetchProductDetail = async (_event,currentVariant) => {
    this?.classList.add('disabled');
    const productWrapper = this.closest('[data-product-wrapper]');
    let url = null;
    if (this.formType == 'quickshop') {
      if (this.swapProductURL) {
        url = `${this.swapProductURL}?option_values=${this.selectedOptionsIndex.toString()}&sections=template-product-quickshop`;
      }else{
        url = `${productWrapper?.getAttribute('data-product-wrapper')}?variant=${currentVariant.id}&sections=template-product-quickshop`;
      }
    }else {
      if (this.swapProductURL) {
        url = `${this.swapProductURL}?option_values=${this.selectedOptionsIndex.toString()}`;
      }else{
        url = `${this.form?.querySelector('[data-product-url]:has(input:checked)')?.getAttribute('data-product-url') || window.location.pathname}?variant=${currentVariant.id}`;
      }
    }

    let response = await fetch(url);
    if (response.ok) {
      let data = this.formType != 'quickshop' ? await response.text() : (await response.json())['template-product-quickshop'];
      const tempResultsHtml = new DOMParser().parseFromString(data, 'text/html').querySelector('[data-product-wrapper]')
      const results = tempResultsHtml?.innerHTML;
      if (results) {
        productVariantsHtml[currentVariant.id] = results;
        if (productWrapper) {
          productWrapper.innerHTML = results;
        }
        let soldOut = productWrapper.querySelector('[name="add"][data-sold-out]');
        let firstActiveEle = productWrapper.querySelector('[name="size"]:checked');
        let notifyMe = productWrapper.querySelector('[data-notify-me]');
        if (soldOut && this.selectedSwatchType == 'color') {
          if (firstActiveEle) {
            // firstActiveEle.checked = false;
            firstActiveEle?.closest('li')?.classList.add('unselect');
            productWrapper.querySelector('[name="select-size"]')?.classList.remove('d-none');
            productWrapper.querySelector('[name="add"]')?.classList.add('d-none');
            notifyMe?.classList.add('d-none');
            productWrapper.querySelector('[data-backorder-date]')?.classList.add('d-none');
          }
        }else if(this.isSizeSelected == true || this.selectedSwatchType == 'size'){
          // firstActiveEle?.closest('li')?.classList.remove('unselect');
          productWrapper?.querySelector('[name="select-size"]')?.classList.add('d-none');
          if (notifyMe) {
            notifyMe.classList.remove('d-none');
            productWrapper?.querySelector('[name="add"]')?.classList.add('d-none');
          }else{
            productWrapper?.querySelector('[name="add"]')?.classList.remove('d-none');
          }
          productWrapper.querySelector('[data-backorder-date]')?.classList.remove('d-none');
          productWrapper.querySelectorAll('.unselect,.hide-oos-line')?.forEach(element => {
            element.classList.remove('unselect','hide-oos-line')
          });
        }
        // let firstActiveEle = productWrapper.querySelector('[data-optionindex="3"] li.active label') || productWrapper.querySelector('[data-optionindex="2"] li.active label');
        // if (soldOut && firstActiveEle) {
        //   firstActiveEle.click();
        // }
        // let secondSelectedEle = productWrapper.querySelector('[data-optionindex="3"] input:checked')?.closest('li');
        // if (!secondSelectedEle?.classList.contains('active')) {
        //   let secondActiveEle = productWrapper.querySelector('[data-optionindex="3"] li.active label');
        //   secondActiveEle?.click();
        // }
      }
    }
    yotpoWidgetsContainer.initWidgets();
    collapsiblePanel?.init();
    if(window.updae_line_index && window.globalVariables.template == 'cart'){
      let submitButton = document.querySelector('quick-shop [type="submit"]:not([disabled])');
      submitButton?.querySelector('[data-add-to-cart-text]').classList.add('d-none');
      submitButton?.querySelector('[data-update-text]').classList.remove('d-none');
    }
    HulkappWishlist?.init();
  }
  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    let notifyMe = this.form.querySelector('[data-notify-me]');
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = "Please select different color";
        this.form.querySelector('[name="select-size"]')?.classList.add('d-none');
        this.form.querySelector('[name="add"]')?.classList.remove('d-none');
        notifyMe?.classList.add('d-none');
        this.form.querySelector('[data-backorder-date]')?.classList.add('d-none');
        this.form.querySelectorAll('.unselect')?.forEach(element => {
          element.classList.add('unselect')
        });
        if (this.form.querySelector('[data-product-option-id]')) {
          setTimeout(() => {
            this.form.querySelector('input[name="color"]+label')?.click();
          }, 500);
        }
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
        this.form.querySelector('[name="select-size"]')?.classList.add('d-none');
        if (notifyMe) {
          notifyMe.classList.remove('d-none');
          this.form.querySelector('[name="add"]')?.classList.add('d-none');
        }else{
          this.form.querySelector('[name="add"]')?.classList.remove('d-none');
        }
        this.form.querySelector('[data-backorder-date]')?.classList.remove('d-none');
        this.form.querySelectorAll('.unselect,.hide-oos-line')?.forEach(element => {
          element.classList.remove('unselect','hide-oos-line')
        });
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
      this.form.querySelector('[name="select-size"]')?.classList.add('d-none');
      notifyMe?.classList.add('d-none');
      this.form.querySelector('[name="add"]')?.classList.remove('d-none');
      this.form.querySelector('[data-backorder-date]')?.classList.remove('d-none');
      this.form.querySelectorAll('.unselect,.hide-oos-line')?.forEach(element => {
        element.classList.remove('unselect','hide-oos-line')
      });
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.variant_json.textContent);
      const hiddenIdsEl = this.closest('product-form')?.querySelector('[data-hiddenVariantIds]');
      if (hiddenIdsEl) {
        try {
          const hiddenIds = JSON.parse(hiddenIdsEl.textContent);
          if (hiddenIds.length > 0) {
            this.variantData = this.variantData.filter(v => !hiddenIds.includes(v.id));
          }
        } catch(e) {}
      }
    }
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;
    // TemplateProductJS.prototype.init_zoom();
  }
}
customElements.define('variant-radios', VariantRadios);